module.exports = __webpack_public_path__ + "static/img/ad.b94a5b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/site-image/ad.jpg
// module id = 8E3W
// module chunks = 169